import { render, staticRenderFns } from "./success.vue?vue&type=template&id=b65e0f10&"
import script from "./success.vue?vue&type=script&lang=ts&"
export * from "./success.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports